import { assistencia24hApiNew } from '@/api/Assistencia24hApi';
import { PrestadorModel } from '@/models/cadastros/assistencia/PrestadorModel';
import { FiltroPrestadorModel } from  "@/models/cadastros/assistencia/FiltroPrestadorModel";

import FiltroServicoDTO from "@/api/servico/FiltroServicoDTO";
import FiltroServicoSemPrestadorDTO from "@/api/servico/FiltroServicoSemPrestadorDTO";

import PageDTO from "@/api/commons/PageDTO";

import {
  FiltroServicosModel,
  FiltroServicosSemPrestadorModel
} from "@/models/solicitacoes";

import {PercentualServicoDTO} from "@/models/commons/ConfiguracaoModel";
import {BancoDTO} from "@/models/commons/BancoModel";
import { PrecosServicoModel } from "@/models/solicitacoes/PrecosServicoModel";
import {FaixaPercentualDTO} from "@/models/solicitacoes/FaixaPercentualServicosModel";
import {RelatorioLogPrecificacaoModel} from "@/models/administracao/log-precificacao/RelatorioLogPrecificacaoModel";
import { SegmentoDTO } from "@/models/commons/SegmentoModel";
import { ClienteFrotaModel } from "@/models/cadastros/assistencia/ClienteFrotaModel";
import { FiltroAgenteModel } from "@/models/cadastros/assistencia/agente/FiltroAgenteModel";
import { AgenteModel } from "@/models/cadastros/assistencia/agente/AgenteModel";
import { QuestionarioModel } from "@/models/cadastros/assistencia/QuestionarioModel";
import { SolicitacaoServicoDTO } from "@/api/assistencia24h/SolicitacaoServicoDTO";
import { QuestionarioBateriaModel } from "@/models/cadastros/assistencia/bateria/QuestionarioBateriaModel";
import { QuestionarioChaveiroModel } from "@/models/cadastros/assistencia/chaveiro/QuestionarioChaveiroModel";
import { QuestionarioGuinchoModel } from "@/models/cadastros/assistencia/guincho/QuestionarioGuinchoModel";
import { QuestionarioTransporteAssociadoModel } from "@/models/cadastros/assistencia/transporteAssociado/QuestionarioTransporteAssociadoModel";
import { QuestionarioTrocaPneuModel } from "@/models/cadastros/assistencia/troca_pneu/QuestionarioTrocaPneuModel";
import {
  converterBateriaModelEmDTO,
  converterChaveiroModelEmDTO,
  converterGuinchoModelEmDTO,
  converterTransporteAssociadoModelEmDTO,
  converterTrocaPneuModelEmDTO,
} from "@/service/conversor/Assistencia24hConversor";
import { ConfirmacaoServicoModel } from "@/models/cadastros/assistencia/ConfirmacaoServicoModel";
import { ConfirmacaoSolicitacaoDTO } from "@/api/assistencia24h/ConfirmacaoSolicitacaoDTO";
import { ConfirmacaoServicoFrotaModel } from "@/models/cadastros/assistencia/ConfirmacaoServicoFrotalModel";
import { ConfirmacaoSolicitacaoFrotaDTO } from "@/api/assistencia24h/ConfirmacaoSolicitacaoFrotaDTO";
// @ts-ignore
import _ from 'lodash';

export default class ServicosAssistenciaService {

  static pesquisarPrecos(filtro:any) : Promise<any> {
    const filtroDTO = {
      cidade: filtro?.cidade,
      estado: filtro?.estado?.sigla,
      tipoServico: filtro.tipoServico?.name,
      tipoVeiculo: filtro.tipoVeiculo?.name,
      bairro: filtro.bairro,
      size: filtro?.options?.itemsPerPage,
      page: filtro?.options?.page ? filtro?.options?.page - 1 : 0
    };
    return assistencia24hApiNew.pesquisarPrecos(filtroDTO);
  }
  
  static salvarPreco(preco: any, valorFinal?:number): Promise<any> {
    let valorServico = undefined;

    if(preco?.tipoServico.name == "TRANSPORTE_ASSOCIADO" || preco?.tipoServico.name == "GUINCHO") {
      valorServico = Number(preco?.valorServico);
    }
    
    const precoDTO = {
      bairro: preco?.bairro,
      cidade: preco?.cidade,
      estado: preco?.estado?.sigla,
      kmOrigemDestino: preco?.kmOrigemDestino ? preco?.kmOrigemDestino : undefined,
      margem: preco?.margem/100,
      tipoServico: preco?.tipoServico.name,
      tipoVeiculo: preco?.tipoServico.name != "TRANSPORTE_ASSOCIADO" ? preco?.tipoVeiculo.name : undefined,
      valorFinal: Number(valorFinal),
      valorKmExcedido:  Number(preco?.valorKmExcedido),
      valorServico: valorServico,
    }

    return assistencia24hApiNew.salvarPreco(precoDTO);
  }
  
  static atualizarPreco(
    preco: any,
    idPreco: number,
    valorFinal?:number
  ): Promise<any> {

    let valorServico = undefined;
    if(preco?.tipoServico.name == "TRANSPORTE_ASSOCIADO" || preco?.tipoServico.name == "GUINCHO") {
      valorServico = Number(preco?.valorServico);
    }

    const precoDTO = {
      bairro: preco?.bairro,
      cidade: preco?.cidade,
      estado: preco?.estado?.sigla,
      kmOrigemDestino: preco?.kmOrigemDestino ? preco?.kmOrigemDestino : undefined,
      margem: preco?.margem/100,
      tipoServico: preco?.tipoServico.name,
      tipoVeiculo: preco?.tipoVeiculo?.name,
      valorFinal: Number(valorFinal),
      valorKmExcedido: Number(preco?.valorKmExcedido),
      valorServico: valorServico,
    }
    
    return assistencia24hApiNew.atualizarPreco(idPreco, precoDTO);
  }
  
  static obterPrecoPorId(idPreco: Number): Promise<any> {
    return assistencia24hApiNew.obterPrecoPorId(idPreco);
  }
  
  static deletarPreco(idPreco: Number): Promise<any> {
    return assistencia24hApiNew.deletarPreco(idPreco);
  }

  
  static savePrestadorAssistencia(prestador: PrestadorModel): Promise<any> {
    return assistencia24hApiNew.savePrestadorAssistencia(prestador);
  }

  static pesquisarPrestadorAssistenciaServicos(filtro: FiltroServicosModel) {

    let filtroApi = new FiltroServicoDTO(
        new PageDTO(
          filtro.paginacao?.page ? filtro.paginacao?.page - 1 : 0,
          filtro.paginacao?.itemsPerPage == -1 ? 9999999: filtro.paginacao?.itemsPerPage || 5
        ),
        filtro?.status,
        filtro.dataDe,
        filtro.dataAte,
        filtro.tipoServico && filtro.tipoServico.trim().length > 0
          ? filtro.tipoServico
          : undefined,
        filtro.numeroServico && filtro.numeroServico.trim().length > 0
          ? filtro.numeroServico
          : undefined
      );

    return assistencia24hApiNew.pesquisarPrestadorAssistenciaServicos(filtroApi);
  }

  static pesquisarServicosAssistencia(filtro: FiltroServicosModel) {

    let filtroApi = new FiltroServicoDTO(
        new PageDTO(
          filtro.paginacao?.page ? filtro.paginacao?.page - 1 : 0,
          filtro.paginacao?.itemsPerPage == -1 ? 9999999: filtro.paginacao?.itemsPerPage || 5
        ),
        _.isEqual(filtro?.status, filtro?.statusServico)
          ? undefined
          : filtro?.status,
        filtro.dataDe,
        filtro.dataAte,
        filtro.tipoServico && filtro.tipoServico.trim().length > 0
          ? filtro.tipoServico
          : undefined,
        filtro.numeroServico && filtro.numeroServico.trim().length > 0
          ? filtro.numeroServico
          : undefined,
        filtro?.statusServico
      );

    return assistencia24hApiNew.pesquisarServicosAssistencia(filtroApi);
  }

  static pesquisarServicosSemPrestador(filtro: FiltroServicosSemPrestadorModel) {

    let filtroApi = new FiltroServicoSemPrestadorDTO(
        new PageDTO(
          filtro.paginacao?.page ? filtro.paginacao?.page - 1 : 0,
          filtro.paginacao?.itemsPerPage == -1 ? 9999999: filtro.paginacao?.itemsPerPage || 5
        ),
        filtro.dataDe,
        filtro.dataAte,
        filtro.tipoServico && filtro.tipoServico.trim().length > 0
          ? filtro.tipoServico
          : undefined,
        filtro.cidade && filtro.cidade.trim().length > 0
          ? filtro.cidade
          : undefined
      );

    return assistencia24hApiNew.pesquisarServicosSemPrestador(filtroApi);
  }


  static gerarRelatorioLogSemPrestadorPDF(filtro : FiltroServicosSemPrestadorModel): Promise<any> {

    let filtroApi = new FiltroServicoSemPrestadorDTO(
      new PageDTO(
        filtro.paginacao?.page ? filtro.paginacao?.page - 1 : 0,
        filtro.paginacao?.itemsPerPage == -1 ? 9999999: filtro.paginacao?.itemsPerPage || 5
      ),
      filtro.dataDe,
      filtro.dataAte,
      filtro.tipoServico && filtro.tipoServico.trim().length > 0
        ? filtro.tipoServico
        : undefined,
      filtro.cidade && filtro.cidade.trim().length > 0
        ? filtro.cidade
        : undefined
    );

    return assistencia24hApiNew.gerarRelatorioLogServicoSemPrestadorPDF(filtroApi);
  }

  static gerarRelatorioLogSemPrestadorXLS(filtro : FiltroServicosSemPrestadorModel): Promise<any> {

    let filtroApi = new FiltroServicoSemPrestadorDTO(
      new PageDTO(
        filtro.paginacao?.page ? filtro.paginacao?.page - 1 : 0,
        filtro.paginacao?.itemsPerPage == -1 ? 9999999: filtro.paginacao?.itemsPerPage || 5
      ),
      filtro.dataDe,
      filtro.dataAte,
      filtro.tipoServico && filtro.tipoServico.trim().length > 0
        ? filtro.tipoServico
        : undefined,
      filtro.cidade && filtro.cidade.trim().length > 0
        ? filtro.cidade
        : undefined
    );

    return assistencia24hApiNew.gerarRelatorioLogServicoSemPrestadorXLS(filtroApi);
  }
  
  static pesquisarPrestadorAssistencia(
    filtro: FiltroPrestadorModel
  ): Promise<any> {
    return assistencia24hApiNew.pesquisarPrestadorAssistencia( 
      filtro?.cpfCnpjFiltro?.replace(/\D/g, "") || '',
      filtro?.nomeFiltro || '',

      filtro.servicoFiltro   ? filtro.servicoFiltro.name!! : "",
      filtro.categoriaFiltro ? filtro.categoriaFiltro.name!! : "",
      
      filtro.paginacao.page ? filtro.paginacao?.page - 1 : 0,
      filtro.paginacao.itemsPerPage || 10,
      filtro.paginacao.sortBy ? filtro.paginacao.sortBy[0] : "",
      filtro.paginacao.sortDesc && filtro.paginacao.sortDesc[0] ? "DESC" : "ASC",

      filtro.estado ? filtro.estado.sigla : "",
      filtro.cidade ? filtro.cidade : ""
    );
  }
  
  static pesquisarAssociadosAssistencia(
    cpfCnpj: string,
    nome: string,
    pagina: number,
    itensPorPagina: number,
    sortColumn: string,
    sortDirection: string,
    estado: string,
    cidade: string
  ): Promise<any> {
    return assistencia24hApiNew.pesquisarAssociadoAssistencia(
        cpfCnpj,
        nome,
        pagina,
        itensPorPagina,
        sortColumn,
        sortDirection,
        estado,
        cidade
    );
  }

  static deletePrestadorAssistencia(id: number): Promise<any> {
    return assistencia24hApiNew.deletePrestadorAssistencia(id);
  }

  static obterPrestador(id: string): Promise<any> {
    return assistencia24hApiNew.obterPrestador(id);
  }

  static obterClienteFrota(id: string): Promise<any> {
    return assistencia24hApiNew.obterClienteFrota(id);
  }

  static saveClienteFrota(cliente: ClienteFrotaModel): Promise<any> {
    return assistencia24hApiNew.saveClienteFrota(cliente);
  }

  static verificarCpfCnpj(cpfCnpj: string): Promise<any> {
    return assistencia24hApiNew.verificarCpfCnpj(cpfCnpj.replace(/\D/g, ""));
  }

  static ativarPrestador(id: number): Promise<any> {
    return assistencia24hApiNew.ativarPrestador(id);
  }

  static inativarPrestador(id: number): Promise<any> {
    return assistencia24hApiNew.inativarPrestador(id);
  }

  static ativarFrota(id: number): Promise<any> {
    return assistencia24hApiNew.ativarFrota(id);
  }

  static ativarCliente(id: number): Promise<any> {
    return assistencia24hApiNew.ativarCliente(id);
  }

  static inativarFrota(id: number): Promise<any> {
    return assistencia24hApiNew.inativarFrota(id);
  }

  static inativarCliente(id: number): Promise<any> {
    return assistencia24hApiNew.inativarCliente(id);
  }

  static obterValorPercentual(id: string): Promise<PercentualServicoDTO> {
    return assistencia24hApiNew.obterValorPercentual(id);
  }

  static ativarFaturamento(id: number): Promise<any> {
    return assistencia24hApiNew.ativarFaturamento(id);
  }
  
  static inativarFaturamento(id: number): Promise<any> {
    return assistencia24hApiNew.inativarFaturamento(id);
  }

  static salvarValorPercentual(configuracao: PercentualServicoDTO): Promise<PercentualServicoDTO> {
    return assistencia24hApiNew.salvarValorPercentual(configuracao);
  }

  static obterBancos(): Promise<BancoDTO[]> {
    return assistencia24hApiNew.obterBancos();
  }

  static salvarBancos(configuracao: BancoDTO): Promise<BancoDTO> {
    return assistencia24hApiNew.salvarBancos(configuracao);
  }

  static atualizarBancos(configuracao: BancoDTO): Promise<BancoDTO> {
    return assistencia24hApiNew.atualizarBancos(configuracao);
  }

  static excluirBanco(id:String) {
    return assistencia24hApiNew.excluirBanco(id);
  }

  static obterConfiguracao(): Promise<PercentualServicoDTO[]> {
    return assistencia24hApiNew.obterConfiguracao();
  }

  static salvarConfiguracao(configuracao: PercentualServicoDTO): Promise<PercentualServicoDTO> {
    return assistencia24hApiNew.salvarConfiguracao(configuracao);
  }

  static obterSegmentos(): Promise<SegmentoDTO[]> {
    return assistencia24hApiNew.obterSegmento();
  }  

  static salvarSegmento(crud: SegmentoDTO): Promise<SegmentoDTO> {
    return assistencia24hApiNew.salvarSegmento(crud);
  }

  static excluirSegmento(id: number) {
    return assistencia24hApiNew.excluirSegmento(id);
  }

  static precosServicos(id: number): Promise<PrecosServicoModel[]> {
    return assistencia24hApiNew.obterPrecosServicos(id);
  }

  static obterFaixaPercentual() {
    return assistencia24hApiNew.obterFaixaPercentual();
  }

  static obterPrestadoresNaRegiao(request : any): Promise<{}> {
    return assistencia24hApiNew.obterPrestadoresNaRegiao(request);
  }

  static obterPrestadorPorPlaca(request : any): Promise<{}> {
    return assistencia24hApiNew.obterPrestadorPorPlaca(request);
  }

  static obterPrestadorPorServico(request : any): Promise<{}> {
    return assistencia24hApiNew.obterPrestadorPorServico(request);
  }

  static excluirFaixaPercentual(id:number) {
    return assistencia24hApiNew.excluirFaixaPercentual(id);
  }

  static salvarFaixaPercentual(faixaPercentualDTO:FaixaPercentualDTO) {
    return assistencia24hApiNew.salvarFaixaPercentual(faixaPercentualDTO);
  }

  static obterTermoDeUso() {
    return assistencia24hApiNew.obterTermoDeUso();
  }

  static downloadTermoDeUso(nomeArquivo:String) {
    return assistencia24hApiNew.downloadTermoDeUso(nomeArquivo);
  }

  static uploadTermoDeUso(foto: File) {
    return assistencia24hApiNew.uploadTermoDeUso(foto);
  }
  
  static filtrarLogPrecificacao(filtro: RelatorioLogPrecificacaoModel): Promise<any> {
    const filtroDTO = {
      numeroServico: filtro.numeroServico,
      cpfCnpjCliente: filtro.cpfCnpjCliente,
      tipoServico: filtro.tipoServico?.name,
      servicoContratado: filtro.servicoContratado?.valor,
      dataPrecificacao: filtro.dataPrecificacao
    };

    return assistencia24hApiNew.filtrarLogPrecificacao(filtroDTO);
  }

  static gerarRelatorioLogPrecificacao(filtro : RelatorioLogPrecificacaoModel): Promise<any> {

    const filtroDTO = {
      numeroServico: filtro.numeroServico,
      cpfCnpjCliente: filtro.cpfCnpjCliente,
      tipoServico: filtro.tipoServico?.name,
      servicoContratado: filtro.servicoContratado?.valor,
      dataPrecificacao: filtro.dataPrecificacao
    }

    return assistencia24hApiNew.gerarRelatorioLogPrecificacao(filtroDTO);
  }

  static gerarRelatorioLogPrecificacaoXls(filtro : RelatorioLogPrecificacaoModel): Promise<any> {

    const filtroDTO = {
      numeroServico: filtro.numeroServico,
      cpfCnpjCliente: filtro.cpfCnpjCliente,
      tipoServico: filtro.tipoServico?.name,
      servicoContratado: filtro.servicoContratado?.valor,
      dataPrecificacao: filtro.dataPrecificacao
    }

    return assistencia24hApiNew.gerarRelatorioLogPrecificacaoXls(filtroDTO);
  }

  static filtrarAgentes(filtro: FiltroAgenteModel): Promise<any> {

    const filtroDTO = {
      cpfCnpj: filtro.cpfCnpjFiltro?.replace(/\D/g,""),
      nome: filtro.nomeFiltro,
      cidade: filtro.cidade,
      estado: filtro?.estado?.sigla,
    };
    return assistencia24hApiNew.filtrarAgentes(filtroDTO);
  }

  static ativarAgente(id: number): Promise<any> {
    return assistencia24hApiNew.ativarAgente(id);
  }

  static inativarAgente(id: number): Promise<any> {
    return assistencia24hApiNew.inativarAgente(id);
  }

  static excluirAgente(id:number) {
    return assistencia24hApiNew.excluirAgente(id);
  }

  static verificarCpfCnpjAgente(cpfCnpj: string): Promise<any> {
    return assistencia24hApiNew.verificarCpfCnpjAgente(cpfCnpj.replace(/\D/g, ""));
  }

  static listarAgentes(): Promise<any> {
    return assistencia24hApiNew.listarAgentes();
  }

  static agentes(): Promise<any> {
    return assistencia24hApiNew.agentes();
  }

  static saveAgente(agente: AgenteModel): Promise<any> {
    return assistencia24hApiNew.saveAgente(agente);
  }

  static obterAgente(id: string): Promise<any> {
    return assistencia24hApiNew.obterAgente(id);
  }

  static obterPreco(questionario: QuestionarioModel) {
    let solicitacaoServicoDTO: SolicitacaoServicoDTO | undefined;

    if (questionario instanceof QuestionarioBateriaModel) {
      solicitacaoServicoDTO = converterBateriaModelEmDTO(questionario);
    } else if (questionario instanceof QuestionarioChaveiroModel) {
      solicitacaoServicoDTO = converterChaveiroModelEmDTO(questionario);
    } else if (questionario instanceof QuestionarioTrocaPneuModel) {
      solicitacaoServicoDTO = converterTrocaPneuModelEmDTO(questionario);
    } else if (questionario instanceof QuestionarioGuinchoModel) {
      solicitacaoServicoDTO = converterGuinchoModelEmDTO(questionario);
    } else if (questionario instanceof QuestionarioTransporteAssociadoModel) {
      solicitacaoServicoDTO = converterTransporteAssociadoModelEmDTO(
        questionario
      );
    }

    if (solicitacaoServicoDTO) {
      solicitacaoServicoDTO.id = questionario.idServico;
      return assistencia24hApiNew.solicitarPrecificacao(
        solicitacaoServicoDTO
      );
    } else {
      throw Error("Não foi possível obter os dados do questionário");
    }
  }

  static confirmarSolicitacao(confirmacaoServico: ConfirmacaoServicoModel) {
    return assistencia24hApiNew.confirmarSolicitacao(
      new ConfirmacaoSolicitacaoDTO(
        confirmacaoServico.idServico,
        confirmacaoServico.idCliente,
        confirmacaoServico.idPagamentoCliente,
        confirmacaoServico.numeroParcelas,
        confirmacaoServico.formaDePagamento,
        confirmacaoServico.pagamentoCliente,
      )
    );
  }

  static uploadFotos(foto: File) {
    return assistencia24hApiNew.efetuarUploadFoto(foto);
  }

  static confirmarSolicitacaoFrota(confirmacaoServico: ConfirmacaoServicoFrotaModel) {
    return assistencia24hApiNew.confirmarSolicitacaoFrota(
      new ConfirmacaoSolicitacaoFrotaDTO(
        confirmacaoServico.idServico,
        confirmacaoServico.idCliente,
        confirmacaoServico.idPagamentoCliente,
        confirmacaoServico.numeroParcelas,
        confirmacaoServico.pagamentoCliente,
        confirmacaoServico.valoresAdministrativo,
        confirmacaoServico.valoresPrecificado,
        confirmacaoServico.idPrestador
      )
    );
  }

  static confirmarSolicitacaoAdm(confirmacaoServico: ConfirmacaoServicoFrotaModel) {
    return assistencia24hApiNew.confirmarSolicitacaoAdm(
      new ConfirmacaoSolicitacaoFrotaDTO(
        confirmacaoServico.idServico,
        confirmacaoServico.idCliente,
        confirmacaoServico.idPagamentoCliente,
        confirmacaoServico.numeroParcelas,
        confirmacaoServico.pagamentoCliente,
        confirmacaoServico.valoresAdministrativo,
        confirmacaoServico.valoresPrecificado
      )
    );
  }

  static recalcularValorServico(confirmacaoServico: ConfirmacaoServicoFrotaModel) {
    return assistencia24hApiNew.recalcularValorServico(
      new ConfirmacaoSolicitacaoFrotaDTO(
        confirmacaoServico.idServico,
        confirmacaoServico.idCliente,
        confirmacaoServico.idPagamentoCliente,
        confirmacaoServico.numeroParcelas,
        confirmacaoServico.pagamentoCliente,
        confirmacaoServico.valoresAdministrativo,
        confirmacaoServico.valoresPrecificado
      )
    );
  }

  static  pesquisarClienteAdministrativoCpfCnpj(filtro: string) {
      return assistencia24hApiNew.pesquisarClienteAdministrativoCpfCnpj(filtro.replace(/\D/g, ""));
  }

  static pesquisarClienteAdministrativoNome(filtro: string) {
     return assistencia24hApiNew.pesquisarClienteAdministrativoNome(filtro);
  }

  static pesquisarPrestadorComplemento(filtro: any) {
     return assistencia24hApiNew.pesquisarPrestadorComplemento(filtro);
  }

}
